<template>
<div class="back-Top" >
  <img src="@/assets/img/common/top.png" alt="">
</div>
</template>

<script>
export default {
  name: "backTop",
}
</script>

<style scoped>
.back-Top{
  position: fixed;
  right: 8px;
  bottom: 55px;
}
.back-Top img{
  width: 48px;
  height: 48px;
}
</style>
